/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import React, {useEffect, useState} from 'react';
import Plot from "react-plotly.js"
import ArgosFlexbox from '../../../components/Containers/ArgosFlexbox';
import {calculateRangeWithBuffer, getMaxFinite} from "../../../../helpers/graphs";


/**
 * Renders the output plot for shape models
 */
const ShapePlot = (props) => {
  const [plottingObject, setPlottingObject] = useState([])
  const run_results = props.plotlyTraces.run_results

  // remove . for nested destructing
  const newObj = {}
  for (const key in run_results){
    const newKey = key.replace(/\./g, "_")
    newObj[newKey] = run_results[key]
  }
  const {actor_d_long_detect, actor_d_lat_detect, actor_d_vert_detect} = newObj

  useEffect(() => {
    constructPlottingObject()
  }, [props])

  const [globalMin, setGlobalMin] = useState(null)
  const [globalMax, setGlobalMax] = useState(null)

  const getPlotRange = (absoluteMin, absoluteMax) => {
    if (globalMin == null || globalMin > absoluteMin) {
      setGlobalMin(absoluteMin)
    }
    if (globalMax == null || globalMax < absoluteMax) {
      setGlobalMax(absoluteMax)
    }
  }
  
  useEffect(() => {
    let _x = actor_d_long_detect?.map(element => Math.abs(element))
    let _y = actor_d_lat_detect?.map(element => Math.abs(element))
    if (_x != null && _y != null) {
      let absoluteMax = getMaxFinite(_x.concat(_y));
      getPlotRange((-1) * absoluteMax, absoluteMax)
    }
  }, [props])

  const constructPlottingObject = () => {
    let _plottingList = []
    let x_list = actor_d_long_detect
    let y_list = actor_d_lat_detect
    let graphType = props?.data?.graphType ?? 'scatter'
    let graphMode = props?.data?.graphMode ?? 'markers'
    let graphName = props?.data?.graphName ?? "Shape Model Graph"
    const graphingObject = {
      x: x_list,
      y: y_list,
      type: graphType,
      mode: graphMode,
      name: graphName,
      marker: {
        size: 3, 
        color: "black",
      },
    }
    _plottingList.push(graphingObject)
    setPlottingObject(_plottingList)
  }

  const {minRange, maxRange} = calculateRangeWithBuffer(globalMin, globalMax)
  
  return (
    <ArgosFlexbox style={{width: '100%', height: '100%', overflow: 'auto', justifyContent: "center"}}>
      <Plot
        data={plottingObject}
        useResizeHandler={true}
        style={{height: 400, width: 400}}
        layout={{
          leyend: {
            bgcolor: "black"
          },
          showlegend: false,
          color: '#ff0000',
          paper_bgcolor: '#f2f4f5',
          plot_bgcolor: '#f2f4f5',
          title: `Shape Model Graph`,
          shapes: {type: 'path',},
          xaxis: {
            title: "Longitudinal Detection Distance - X (m)",
            rangemode: "tozero",
            nticks: 6,
            range: [minRange, maxRange],
          },
          yaxis: {
            title: "Lateral Detection Distance - Y (m)",
            range: [minRange, maxRange],
            rangemode: "tozero",
            nticks: 6,
          },
        }}
      />
    </ArgosFlexbox>
  )
}

export default ShapePlot
